import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { nativeNetworkCurrencyAtom } from '@root/entities/currency'
import { CurrencyIcon } from '@root/entities/currency/ui'
import { Network } from '@root/entities/network'
import { SummaryChartMiniature } from '@root/entities/summary/ui/summary-chart/desktop/summary-chart-miniature'
import { walletsModelAtom } from '@root/entities/wallet'
import { AmountFormatted } from '@root/shared/core/format'

type Props = {}

export const WalletsHeaderSummary: React.FC<Props> = () => {
  const { t } = useTranslation()

  const [nativeCurrency] = useAtom(nativeNetworkCurrencyAtom)
  const [model] = useAtom(walletsModelAtom)
  const [totalBalanceNative] = useAtom(model.totalBalanceNative)
  const [totalBalanceUsd] = useAtom(model.totalBalanceUsd)
  const [wallets] = useAtom(model.wallets)

  const title = `${Network.label(nativeCurrency.network)} ${t('wallet_other')}`

  return (
    <Root>
      <CurrencyIcon currency={nativeCurrency} size={20} />
      <TitleContainer>
        <Title>{title}</Title>
        <WalletsCount>
          {wallets.length} {t('wallet', { count: wallets.length })}
        </WalletsCount>
      </TitleContainer>
      <Separator />
      <BalanceContainer>
        <BalanceNative>
          <AmountFormatted
            currency={nativeCurrency.ticker}
            amount={totalBalanceNative}
            roundingMode="trunc"
          />
        </BalanceNative>
        <BalanceUsd>
          <AmountFormatted
            currency="$"
            amount={totalBalanceUsd}
            roundingMode="trunc"
          />
        </BalanceUsd>
      </BalanceContainer>

      <Chart wallet={undefined} />
    </Root>
  )
}

const Root = styled.div`
  border-radius: 8px;
  background: var(--appearanceA-3, var(--appearanceA-3));
  height: 56px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  padding-inline: 10px;
`

const Title = styled.div`
  color: var(--text-12);

  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

const WalletsCount = styled.div`
  color: var(--text-7);

  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
`

const TitleContainer = styled.div`
  margin-left: 8px;
  min-width: 140px;
  display: grid;
  gap: 4px;
`

const Separator = styled.div`
  width: 1px;
  height: 36px;
  background: var(--background-2);
`

const BalanceContainer = styled.div`
  margin-inline: 20px;
  display: grid;
  gap: 2px;

  min-width: 64px;
`

const BalanceNative = styled.div`
  color: var(--text-12);

  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
`

const BalanceUsd = styled.div`
  color: var(--text-9);

  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
`

const Chart = styled(SummaryChartMiniature)`
  width: 126px;
  height: 40px;
`
